import { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.scss';
import { Header, Snackbar, WideMode } from './components';
import { AuthContext } from './context';
import { SettingsContext } from './context/SettingsContext';
import { useWideMode } from './hooks';
import { EditListPage, EmailLinkSigninPage, InsightsPage, SettingsPage, SpellDisplayPage, SpellListPage, SpellsReferencePage } from './pages';
import { ListsPage } from './pages/ListsPage/ListsPage';

function App() {
  const { isLoggedIn } = useContext(AuthContext);
  const { darkMode } = useContext(SettingsContext);
  const isWide = useWideMode();

  const leftPaneRoutes = (
    <Routes>
      {isLoggedIn && <Route path="/settings" element={<SettingsPage />} />}
      <Route path="/emaillinksignin" element={<EmailLinkSigninPage />} />
      <Route path="/" element={<SpellsReferencePage />} />
      <Route path="/insights" element={<InsightsPage />} />
      <Route path="*" element={<SpellsReferencePage />} />
      {isLoggedIn && (
        <>
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/lists/:listId" element={<SpellListPage />} />
          <Route path="/lists/edit" element={<EditListPage />} />
          <Route path="/lists/:listId/edit" element={<EditListPage />} />
        </>
      )}
    </Routes>
  );

  const mainRoutes = (
    <Routes>
      {isLoggedIn && <Route path="/settings" element={<SettingsPage />} />}
      <Route path="/emaillinksignin" element={<EmailLinkSigninPage />} />
      <Route path="/" element={<SpellsReferencePage />} />
      <Route path="/insights" element={<InsightsPage />} />
      <Route path="/:spellId" element={<SpellDisplayPage />} />
      <Route path="*" element={<SpellsReferencePage />} />
      {isLoggedIn && (
        <>
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/lists/:listId" element={<SpellListPage />} />
          <Route path="/lists/edit" element={<EditListPage />} />
          <Route path="/lists/:listId/edit" element={<EditListPage />} />
        </>
      )}
    </Routes>
  );

  return (
    <div className={`App ${isLoggedIn && darkMode ? 'DarkMode' : ''}`}>
      <Header />
      {isWide ? (
        <WideMode left={leftPaneRoutes} right={<SpellDisplayPage />} />
      ) : (
        mainRoutes
      )}
      <Snackbar />
    </div>
  );
}

export default App;
